import { render } from "./DragImages.vue?vue&type=template&id=6e57e5b5&scoped=true"
import script from "./DragImages.vue?vue&type=script&lang=js"
export * from "./DragImages.vue?vue&type=script&lang=js"

import "./DragImages.vue?vue&type=style&index=0&id=6e57e5b5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e57e5b5"]])

export default __exports__